/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgGavel = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m13.314 2-2.828 2.829h-.001l-5.656 5.655L2 13.314l7.071 7.07 2.828-2.828 2.122-2.121 6.899 6.899 1.414-1.414-6.899-6.9 2.122-2.12 2.828-2.83zM11.9 6.243l1.414-1.414 4.243 4.241-1.415 1.416zm-4.243 4.241 2.829-2.827 4.242 4.243-2.829 2.828zm-2.829 2.83 1.415-1.415 4.242 4.243-1.414 1.414z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgGavel as Gavel };
